import buttonsStyle from './buttonsStyle';

const CropImageStyle = (theme) => ({
  crop: {
    positoon: 'relative',
    overflow: 'auto',
  },
  divImage: {
    padding: '0px 24px',
  },
  moduleImage: {
    //   background:'#189b5430',
    marginRight: 10,
    width: 93,
    height: 93,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    border: '1px solid #D8D8D8',

    '& svg': {
      fill: '#189b54',
      width: 55,
      height: 55,
    },
  },
  cropButton: {
    background: '#fff',
    color: '#000',
    border: 0,
    padding: '5px 35px',
    fontSize: '18px',
    cursor: 'pointer',
    margin: '10px 0',
  },
  cropImage: {
    borderRadius: '5px',
    maxWidth: '100%',
    margin: 8,
  },
  dialogImgUser: {
    backgroundImage: theme.palette.modalsContentBg.backgroundImage,
  },

  fromRequestDemoTitle: {
    display: 'none!important',
  },
  fromRequestDemoContent: {
    padding: '0px!important',
    marginBottom: '0px!important',
  },

  fromRequestDemo: {
    background: '#1111118c',
    '& > div:nth-child(3) > div': {
      marginTop: '-105px!important',
      width: '600px!important',

    },
    '& .MuiBackdrop-root': {
      background: '#1111118c',
    },
    '& .modal-content ': {
      background: theme.palette.formPage.modalContentBg,
      borderRadius: '10px',
      height: '308px',
    },
    '& .modal-dialog': {
      padding: '0px',
      // marginTop: '150px !important',
      margin: '0px auto',
    },
    '& .failure-div ': {
      '& .modal-body': {
        border: '1px solid #f94141',
      },
      '& .action-button': {
        background: '#f94141',
      },
      '& .modal-body h2': {
        color: '#f35252',
      },
      '& .action-button:hover, .action-button:focus': {
        boxShadow: '0 0 0 0px white, 0 0 0 3px #f35252!important',
      },
    },

    '& .modal-body h2': {
      fontSize: '14px',
      textTransform: 'capitalize',
      color: theme.palette.formPage.modalCol,
      fontFamily: 'Helvetica',
      fontWeight: '500',
      textAlign: 'center',
    },
    '& .modal-footer': {
      padding: '15px',
      textAlign: 'right',
    },
    '& .action-button': {
      width: '100px',
      background: '#0aaf58',
      fontWeight: 'bold',
      color: 'white',
      border: '0 none',
      borderRadius: '25px',
      cursor: 'pointer',
      padding: '12px 22px',
      margin: '10px 5px',
      fontSize: '14px',
      transition: '0.7s',
    },
    '& #msform2 .action-button:hover, #msform .action-button:focus': {
      boxShadow: '0 0 0 0px white, 0 0 0 3px #0aaf58',
      transition: '0.7s',
      background: 'transparent',
      color: theme.palette.formPage.modalCol,
    },
    '& .modal-body': {
      padding: '0px',
      display: 'block',
      width: '90%',
      margin: 'auto',
      background: ' rgb(244 255 246 / 2%)',
      border: '1px solid #099b4e',
      borderRadius: '9px',
      marginTop: '30px',
    },
    '& .modal-header': {
      border: ' 0px !important',
      background: theme.palette.formPage.modalHeaderBg,
      padding: '18px',
      textAlign: 'center',
      height: '140px',
      '& img': {
        width: '104px',
        height: '104px',
        borderRadius: '50%',
      },

    },
    dialogContent: {
      padding: '0px',
    },
  },
  dialogImg: {
    width: '128px',
    content: "''",
    borderRadius: '49.9%',
    position: 'absolute',
    backgroundColor: theme.palette.modalsContentBg.color,
    height: '128px',
    left: '50%',
    zIndex: '-1',
    top: '-51px',
    transform: 'translate(-50%,0px)',
  },

  dialogTitle: {
    borderRadius: '10px',
    color: theme.palette.modalTextColor.color,
    background: theme.palette.modalsContentBg.color,
    width: '100%',
    boxSizing: 'border-box',
    '& svg:nth-child(2)': {
      '& path': {
        // fill: theme.palette.text.primary,
      },
      position: 'absolute',
      top: '-35px',
      width: '36px',
      height: '36px',
      fill: theme.palette.text.primary,
    },
    '& h2': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '1.3rem',
      fontWeight: 'light',
      lineHeight: '1',
    },
    '@media (max-width: 767px)': {
      minWidth: 'inherit',
      padding: '16px 10px',
    },
  },
  dialogHeader: {
    background: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    padding: '5px 15px',
  },
  dialogAction: {
    background: theme.palette.modalsContentBg.color,
    justifyContent: 'space-between',
    padding: '0 20px 10px',
  },
  dialogContent: {
    color: theme.palette.secondary.contrastText,
    background: theme.palette.modalsContentBg.color,
    minHeight: 'auto',
    padding: '8px 26px',
    borderRadius: '10px',
    marginBottom: '10px',
    '@media (max-width: 767px)': {
      minWidth: 'inherit',

    },
  },
  cancelCrossIcon: {
    color: theme.palette.primary.contrastText,
    minWidth: 'inherit',
    position: 'absolute',
    top: -10,
    right: -10,
    padding: 0,
    height: 24,
    width: 24,
    borderRadius: '50%',
    border: `2px solid ${theme.palette.borderDark.color}`,
    background: theme.palette.modalsContentBg.color,
    '& svg': {
      width: 14,
      height: 14,
      fill: theme.palette.modalTextColor.color,
    },
    '&:hover': {
      backgroundColor: theme.palette.modalsContentBg.color,
    },
  },
  extraRighSpace: {
    right: 40,
    cursor: 'pointer',
  },
  defaultButton: {
    ...buttonsStyle.defaultButton,
    color: '#1e1c1c',
    background: theme.palette.defaultBtnShadow.background,
    '&:hover': {
      background: theme.palette.defaultBtnShadow.backgroundHover,
      color: '#1e1c1c',
      boxShadow: theme.palette.defaultBtnShadow.boxShadow,
    },
  },
  dialogMinWidth: {
    width: '600px',
  },
  textColor: {
    color: theme.palette.secondary.main,
  },
  activeButton: {
    borderRadius: '28px!important',
    width: 'auto',
    '&:hover': {
      background: '#189b54',
      opacity: 0.9,
    },
    '&.Mui-disabled': {
      color: '#fff',
      cursor: 'not-allowed',
      pointerEvents: 'inherit',
      background: '#189b5496',
      borderRadius: '28px!important',
      '&:hover': {
        background: '#189b5496',
        cursor: 'not-allowed',
      },

    },
    ...buttonsStyle.activeButton,
    color: '#fff',
    background: '#01BD5A',

  },
  h4Styles: {
    color: theme.palette.primary.main,
    margin: 0,
  },
  chipsBox: {
    float: 'left',
    margin: '10px 10px 0 0',
  },
  linkColor: {
    color: theme.palette.secondary.contrastText,
    cursor: 'pointer',
  },
  hiddenScroll: {
    overflowY: 'visible',
  },
  marginFive: {
    margin: '8px 0',
  },
  marginBottomSpacing: {
    marginBottom: 15,
    position: 'relative',
    width: '100%',
    float: 'left',
  },
  modalBodyScroll: {
    overflowY: 'auto',
    maxHeight: 'calc(100vh - 190px)',
    overflowX: 'hidden',
    // paddingBottom: 20
  },
  modalContainer: {
    '& > div:nth-child(3) > div': {
      maxWidth: 'inherit',
      width: 750,
      overflow: 'inherit',
      borderRadius: '10px',
      background: theme.palette.modalsContentBg.color,
      boxShadow: 'none!important',
      //    zIndex:"-1",

    },
  },
  historyModal: {
    '& form button': {
      '&:first-child': {
        marginRight: 10,
      },
    },
    '& > div:nth-child(3) > div': {
      width: 700,
      background: theme.palette.modalsContentBg.color,
      '& > div + div': {
        padding: '8px 26px',
        background: 'none',
        '& > div > div': {
          padding: '0 25px 30px',
        },
      },
      '@media (max-width:767px)': {
        width: '90%',
        margin: '32px 10px',
        maxWidth: '100%',
        '& > div + div': {
          padding: '0',
          '& > div > div': {
            padding: '0 15px 30px',
          },
        },
      },
    },
  },
  templateModel: {
    '& form button': {
      '&:first-child': {
        marginRight: 10,
      },
    },
    '& > div:nth-child(3) > div': {
      width: 840,
      background: theme.palette.modalsContentBg.color,
      '& > div + div': {
        padding: '8px 26px',
        background: 'none',
        '& > div > div': {
          padding: '0 25px 30px',
        },
      },
      '@media (max-width:767px)': {
        width: '90%',
        margin: '32px 10px',
        maxWidth: '100%',
        '& > div + div': {
          padding: '0',
          '& > div > div': {
            padding: '0 15px 30px',
          },
        },
      },
    },
  },
  adjustModalSize: {
    '& .MuiDialog-paperWidthSm': {
      maxWidth: '600px !important',
      '& label': {
        color: `${theme.palette.secondary.contrastText} !important `,
      },
      '& input': {
        color: `${theme.palette.secondary.contrastText} !important `,
        borderBottom: `1px solid ${theme.palette.secondary.contrastText} !important`,
      },
    },
  },
  cropModal: {
    '& > div:nth-child(3)': {
      overflow: 'inherit',
      '& > div': {
        overflow: 'inherit',
      },
    },
  },
});
export default CropImageStyle;
